import { createGenerateClassName, StylesProvider } from '@material-ui/core';
import * as React from 'react';
import { SidePanelContainer } from '../common/sidePanel';
import { NavbarContainer } from '../navbar';
import { TimelineContainer } from '../timeline';

const classNameGenerator = createGenerateClassName({
  productionPrefix: 'adv-preview-'
});

const App: React.SFC = () => (
  <StylesProvider generateClassName={classNameGenerator}>
    <SidePanelContainer>
      <div className="ap">
        <NavbarContainer />
        <TimelineContainer />
      </div>
    </SidePanelContainer>
  </StylesProvider>
);

export default App;



// WEBPACK FOOTER //
// ./src/components/app/App.tsx